import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { postWithAuth } from '../common'
import { apiQueryKey, queryClient } from './queryClient'

export function useApiQuery(endpoint, body, options = {}) {
    const userId = useSelector(state => state.user.user?.id) || 'session'
    return useQuery({
        queryKey: apiQueryKey(userId, endpoint, body),
        queryFn: async () => {
            const result = await postWithAuth(endpoint, body, { uncached: true })
            if (result?.err) throw new Error(result.err)
            return result
        },
        ...options,
    }, queryClient)
}
